(function($){
  if (window.Catawiki === undefined || window.Catawiki === null) {
    window.Catawiki = {};
  }
  var Catawiki = window.Catawiki;

  Catawiki.initExtendedSelect = function (){
    var $selects = $('.cw-extended_select');
    $selects.each(function(){
      var $select = $(this);
      if ($select.prop('initialized')) { return true; }
      $select.prop('initialized', true);
      var $container = $select.closest('.mfp-content, .cw_main_container, body').eq(0);
      var $selected = $select.find('.cw-extended_select-selected');
      var $options = $select.find('.cw-extended_select-options');
      var $option_items = $options.children('li');
      var $option_links = $options.find('a');
      var $field = $select.find('input').eq(0);
      setTimeout(function(){
        $options.css({
          'max-height': $container.height() - ($select.offset().top - $container.offset().top) - 50
        });
      }, 0);
      var activateSelected = function (){
        $option_items.removeClass('active');
        $this.parent().addClass('active');
      };
      $options.find('a')
        .attr('tabindex', 1)
        .on('mousedown touchstart', function(evt){
          evt.stopPropagation();
        })
        .on('focus', function(){
          $select.addClass('open');
        })
        .on('blur', function(){
          $select.removeClass('open');
        })
        .on('click.extended_select', function(evt){
          evt.preventDefault();
          $this = $(this);
          $field.val($this.data('option_value'));
          var txt = $this.clone().children().remove().end().text();
          $selected.text(txt).attr('title', txt);
          $select.removeClass('open');
          if (!$this.parent().hasClass('active')) {
            if ($this.data('option_callback')) {
              $this.data('option_callback').call(this, evt, activateSelected);
            } else {
              activateSelected.call(this);
            }
          }
        });
      $selected
        .attr('tabindex', 1)
        .on('mousedown.extended_select', function(evt){
          evt.stopPropagation();
          if ($select.hasClass('open')) {
            $select.removeClass('open');
          } else {
            $selects.removeClass('open');
            $select.addClass('open');
          }
        })
        .on('focus.extended_select', function(evt){
          if (!$select.hasClass('open')) {
            $select.addClass('open');
          }
        });
      $('body')
        .on('mousedown.extended_select touchstart.extended_select', function(){
          $selects.removeClass('open');
        });
    });
  };
})(jQuery);
